/**
 * GoldSpinner — minimalist thin golden ring loader.
 */
export function GoldSpinner({ size = 28, className = "", label = "Chargement" }) {
  return (
    <div
      role="status"
      aria-label={label}
      data-testid="gold-spinner"
      className={`inline-flex items-center justify-center ${className}`}
    >
      <span
        className="gold-spinner"
        style={{ width: size, height: size }}
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}

/**
 * GoldSkeleton — gold-shimmer placeholder block.
 */
export function GoldSkeleton({ className = "", style = {} }) {
  return (
    <div
      aria-hidden="true"
      data-testid="gold-skeleton"
      className={`skeleton-gold ${className}`}
      style={style}
    />
  );
}

/**
 * FullPageLoader — centered branded loader with gold ring + caption.
 */
export function FullPageLoader({ caption = "Chargement…" }) {
  return (
    <div
      data-testid="full-page-loader"
      className="min-h-screen flex flex-col items-center justify-center bg-[#050505] text-zinc-500 font-body gap-4"
    >
      <GoldSpinner size={36} />
      <span className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">
        {caption}
      </span>
    </div>
  );
}
